

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ExecutionErrorFormComponent } from './executionerror-form/executionerror-form.component';
import { ExecutionErrorComponent } from './executionerror.component';
import { ExecutionErrorRoutes } from './executionerror.routing';

export function declaration() {
    return [ExecutionErrorComponent, ExecutionErrorFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ExecutionErrorModule {
}

@NgModule({
    imports: [ExecutionErrorModule, ExecutionErrorRoutes],
    exports: [ExecutionErrorModule]
})
export class ExecutionErrorWithRouteModule {
}
